import * as z from 'zod';
import { workInProgressScheduleExtractionId, wipLineItemId, isoDateTimeSchema, userId, wipProjectId } from '../../types/opaque.mjs';
import { wipAtomicFieldsSchema, wipJobStatusSchema, wipRowKindSchema, wipConfidenceTierSchema } from '../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import { currencySchema } from '../../types/utils.mjs';

var Metrics;
(function (Metrics) {
    Metrics.schema = wipAtomicFieldsSchema.extend({
        extracted: wipAtomicFieldsSchema,
        estimatedCostToComplete: currencySchema.nullable(),
        estimatedGrossProfit: currencySchema.nullable(),
        grossProfitPercent: z.number().nullable(),
        percentComplete: z.number().nullable(),
        cumulativeRevenueEarned: currencySchema.nullable(),
        grossProfitEarnedToDate: currencySchema.nullable(),
        grossProfitToBeEarned: currencySchema.nullable(),
        underbillings: currencySchema.nullable(),
        overbillings: currencySchema.nullable(),
        pureJobBorrow: currencySchema.nullable(),
        cashFlowRemaining: currencySchema.nullable(),
    });
})(Metrics || (Metrics = {}));
var Get;
(function (Get) {
    (function (Response) {
        Response.schema = Metrics.schema.extend({
            id: wipLineItemId,
            extractionId: workInProgressScheduleExtractionId,
            projectId: wipProjectId.nullable(),
            projectName: z.string().nullable(),
            projectNumber: z.string().nullable(),
            extractedProjectName: z.string().nullable(),
            extractedProjectNumber: z.string().nullable(),
            rowKind: wipRowKindSchema,
            jobStatus: wipJobStatusSchema,
            confidence: wipConfidenceTierSchema.nullable(),
            sourceRefId: z.string().nullable(),
            modifiedByUserId: userId.nullable(),
            modifiedAt: isoDateTimeSchema.nullable(),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Update;
(function (Update) {
    (function (Admin) {
        (function (Request) {
            Request.schema = wipAtomicFieldsSchema
                .partial()
                .extend({
                jobStatus: wipJobStatusSchema.optional(),
                projectName: z.string().nullish(),
                projectNumber: z.string().nullish(),
            })
                .refine((data) => Object.values(data).some((v) => v !== undefined), {
                message: "At least one field is required",
            });
        })(Admin.Request || (Admin.Request = {}));
    })(Update.Admin || (Update.Admin = {}));
})(Update || (Update = {}));
var AssignProject;
(function (AssignProject) {
    (function (Admin) {
        (function (Request) {
            Request.schema = z.object({ projectId: wipProjectId });
        })(Admin.Request || (Admin.Request = {}));
    })(AssignProject.Admin || (AssignProject.Admin = {}));
})(AssignProject || (AssignProject = {}));

export { AssignProject, Get, Metrics, Update };
